export const environment = {
    production: false,
    LAUNCHDARKLY_CLIENT_ID: '6177d27ec9dff82419893c1c',
    API_URL: 'https://pg.dev.sfey.com',
    TPS_AUTH_URL: 'https://auth.pg.test.sfey.com',
    OAUTH_CLIENT_ID: 'PGRidangoDevTPSNewAdminUI',
};
